import { React, useEffect, useState } from "react";
import {  useParams } from "react-router-dom";

import { getClientUser } from "../utils/Api";
import { handleLoaderEvent } from "../utils/LoaderEmitter";

import ReactPaginate from "react-paginate";
import EditClientUser from "./EditClientUser";
import ClientNavigation from "./ClientNavigation";

import "../styles/ViewUsers.css";

const ViewClientUser = () => {
  const [users, setUsers] = useState([]);
  const [itemsPerPage, setitemsPerPage] = useState(5);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [currentItems, setCurrentItems] = useState();

  let { id } = useParams();

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(users?.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(users?.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, users]);

  useEffect(() => {
    refreshContent();
  }, []);

  const refreshContent = async () => {
    handleLoaderEvent.emit("loader", true);
    setUsers([]);
    let usersData = await getClientUser(id);
    if (!usersData) {
      return;
    }
    setUsers(usersData.users.reverse());

    handleLoaderEvent.emit("loader", false);
  };

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % users.length;
    setItemOffset(newOffset);
  };

  const userUpdatedHandler = () => {
    refreshContent();
  };

  const userRows = (currentItems) =>
    currentItems?.map((user) => {
      return (
        <>
          <EditClientUser key={user.id} user={user} showEditOption={false} userUpdated={userUpdatedHandler}></EditClientUser>
        </>
      );
    });

  const userTable = () => {
    return (
      <>
        <table className="container-fluid p-0">
          <thead>
            <tr className="mb-4 table-header">
              <th style={{ width: "20%" }}>Name</th>
              <th style={{ width: "15%" }}>Department</th>
              <th style={{ width: "25%" }}>Email</th>
              <th style={{ width: "20%" }}>Assigned Skills</th>
              <th style={{ width: "40%" }}>Actions</th>
            </tr>
          </thead>
          <tbody>{userRows(currentItems)}</tbody>
        </table>
      </>
    );
  };

  return (
    <>
      <ClientNavigation id={id} selectedTab={"Manage Users"}></ClientNavigation>
      <div className="row p-0 m-0 screen-header mt-4 mb-3 p-1">
        <div className="col content-title ps-4">Users</div>
        <div className="col-auto"></div>
      </div>
      <div className="user-table">{userTable(users)}</div>
      <div className="row p-0 m-0 mt-4">
        <div className="col-auto px-2 d-flex align-items-center">Rows Per Page</div>
        <div className="col-auto px-2 d-flex align-items-center">
          <button className="btn dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
            {itemsPerPage}
          </button>
          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li>
              <div className="dropdown-item" onClick={() => setitemsPerPage(5)}>
                5
              </div>
            </li>
            <li>
              <div className="dropdown-item" onClick={() => setitemsPerPage(10)}>
                10
              </div>
            </li>
          </ul>
        </div>
        <div className="col p-0 d-flex justify-content-end">
          <ReactPaginate
            nextLabel=">"
            onPageChange={handlePageClick}
            pageRangeDisplayed={4}
            marginPagesDisplayed={2}
            pageCount={pageCount}
            previousLabel="<"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination"
            activeClassName="active"
            renderOnZeroPageCount={null}
          />
        </div>
      </div>
    </>
  );
};
export default ViewClientUser;
